import _toConsumableArray from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _objectSpread from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.push.js";
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex';
import s from 'storejs';
var rootRoute = {
  path: '/dashboard',
  name: 'Dashboard',
  meta: {
    title: '1108',
    icon: 'dashboard'
  }
};
export default {
  data: function data() {
    return {
      showActive: true,
      // 是否展示控制按钮
      translate: 0,
      // 滚动位置
      step: 300,
      // 移动步长
      animate: false
    };
  },
  watch: {
    $route: function $route(to, form) {
      var _this = this;
      this.$nextTick(function () {
        // 路由跳转判断是否存在列表中
        _this.handlerRecord(to, form);
      });
    }
  },
  computed: _objectSpread(_objectSpread({}, mapGetters({
    routes: 'accessRecord',
    permissionRoutes: 'routes',
    sidebar: 'sidebar'
  })), {}, {
    isCollapse: function isCollapse() {
      return !this.sidebar.opened;
    },
    // 计算宽度
    navWidth: function navWidth() {
      return this.isCollapse ? 48 : 216;
    },
    tapsStyle: function tapsStyle() {
      var navWidth = this.navWidth;
      return {
        left: "".concat(navWidth, "px"),
        width: "calc(100% - ".concat(navWidth, "px)")
      };
    },
    currentIndex: function currentIndex() {
      var _this2 = this;
      return this.routes.findIndex(function (item) {
        return item.path === _this2.$route.path;
      });
    }
  }),
  mounted: function mounted() {
    this.init();
    // window.addEventListener(
    //   'resize',
    //   this.$util.debounce(() => {
    //     this.resize()
    //   }, 500)
    // )
  },

  methods: {
    init: function init() {
      var _this3 = this;
      // const routes = s.get('accessRecord') || []
      // // 获取历史访问数据
      // this.handlerGetStorageDataForSaveStore(routes)
      // this.initHistoryAccess()
      // 是否包含当前路由
      this.$nextTick(function () {
        return _this3.handlerRecord(_this3.$route);
      });
    },
    // 初始化组件读取localStorage中的历史记录
    // 根据用户权限筛选出最新的
    initHistoryAccess: function initHistoryAccess() {
      // // 本地存储的访问记录
      var accessRecord = localStorage.getItem('accessRecord') || '[]';
      var historyRoutes = JSON.parse(accessRecord);
      // 更新store到全局
      this.handlerGetStorageDataForSaveStore(historyRoutes);
    },
    /**
     *   判断路由列表中是否存在当前路由 无则添加
     *   之后跳转到可视区域
     *   @parma { Object } to 目标路由
     */
    handlerRecord: function handlerRecord(to, form) {
      var _this4 = this;
      var path = to.path,
        meta = to.meta,
        query = to.query;
      // 判断是否包含当前路由
      var findIndex = this.routes.findIndex(function (item) {
        return item.path === path;
      });
      var isInclude = this.routes.some(function (item) {
        return item.path === path;
      });
      if (!to && isInclude) return this.$nextTick(function () {});
      var typeForm = '';
      var pathForm = '';
      var formIndex = -1;
      if (form) {
        typeForm = form.meta.type;
        pathForm = form.path;
        formIndex = this.routes.findIndex(function (item) {
          return item.path === form.path;
        });
      }
      var newRoutes = [];
      if (findIndex !== -1) {
        // findIndex不为-1，删除后面路由
        newRoutes = this.routes.slice(0, findIndex + 1);
      } else {
        // from.path 和 to.meta.type 相等说明为父子关系
        if (pathForm === meta.type) {
          newRoutes = [].concat(_toConsumableArray(this.routes), [{
            path: path,
            meta: meta,
            query: query
          }]);
        } else if (typeForm === meta.type) {
          // from.meta.type和to.meta.type相等说明是兄弟关系
          this.routes.splice(formIndex, 1);
          newRoutes = [].concat(_toConsumableArray(this.routes), [{
            path: path,
            meta: meta,
            query: query
          }]);
        } else {
          newRoutes = [{
            path: path,
            meta: meta,
            query: query
          }];
        }
      }
      // 当前只有一层路由 获取第一层路由信息
      if (newRoutes.length === 1 && path !== '/dashboard') {
        var all = [];
        var deepScreen = function deepScreen(routes) {
          var deepFun = function deepFun(routes) {
            if (!routes) return;
            return routes.filter(function (item) {
              if (meta && meta.module) {
                var module = meta.module.split(',');
                module.forEach(function (mod) {
                  if (item.name === mod && mod !== path) {
                    all.push(item);
                  }
                });
              }
              return deepFun(item.children);
            });
          };
          return deepFun(routes);
        };
        deepScreen(this.permissionRoutes);
        if (all.length) {
          all.reverse().forEach(function (item) {
            newRoutes.unshift({
              path: item.meta.module ? item.name : '',
              meta: item.meta
            });
          });
        }
      }
      this.$nextTick(function () {
        _this4.handlerGetStorageDataForSaveStore(newRoutes);
      });
    },
    /**
     *  获取或者存储路由数据
     *  @param { Object } routes 路由列表
     *  @param { Boolean } state 是否跳转可视区域
     */
    handlerGetStorageDataForSaveStore: function handlerGetStorageDataForSaveStore(routes, state) {
      // 没有路由时添加默认路由
      var isInclude = routes.some(function (item) {
        return item.path === '/dashboard';
      });
      if (!isInclude && !routes.length) {
        routes.unshift(rootRoute);
      }
      s.set('accessRecord', routes);
      this.$store.dispatch('permission/setAccessRecord', routes);
    }
  }
};